/**
 * New box after a drag/resize gesture. Layers can now extend beyond the
 * canvas edges entirely (e.g. an image positioned so only its top half
 * is visible, the rest hanging below the banner) - #ad's own overflow:
 * hidden already clips whatever falls outside, so this was purely a UI
 * gesture decision, not a rendering limitation. Applies to every layer
 * type uniformly, including text - a user can drag a headline partially
 * off-canvas, which is an accepted trade-off (on the designer, not
 * prevented by the platform), not scoped to images only.
 *
 * Min size (8px) is preserved - unrelated to canvas bounds, still a
 * sensible floor against a zero/negative-size box either way.
 */
export function gestureBox(mode, b, dx, dy) {
  const MIN = 8;
  if (mode === "move") {
    return { ...b, x: Math.round(b.x + dx), y: Math.round(b.y + dy) };
  }
  let { x, y, w, h } = b;
  if (mode.includes("e")) w = b.w + dx;
  if (mode.includes("s")) h = b.h + dy;
  if (mode.includes("w")) {
    x = b.x + dx;
    w = b.w - dx;
  }
  if (mode.includes("n")) {
    y = b.y + dy;
    h = b.h - dy;
  }
  if (w < MIN) {
    if (mode.includes("w")) x = b.x + b.w - MIN;
    w = MIN;
  }
  if (h < MIN) {
    if (mode.includes("n")) y = b.y + b.h - MIN;
    h = MIN;
  }
  return { ...b, x: Math.round(x), y: Math.round(y), w: Math.round(w), h: Math.round(h) };
}